module.exports = __webpack_public_path__ + "img/SEVS_16기모집.8a336642.png";